import { useEffect, useState } from "react"
import { InformeAI } from "../../interfaces/PlanesInterface"
import { API_AUDITORIAS } from "../../features/constants";
import { Users } from "../../interfaces/UserInterface";


interface InformesProps{
    informeSelect?: InformeAI | undefined
    setInformeSelect: React.Dispatch<React.SetStateAction<InformeAI | undefined>>
    update?: Boolean
}

export const ListaInformesAuditoriasInternas = ({informeSelect,setInformeSelect,update}:InformesProps)=>{
    
    let localUser = localStorage.getItem("localUser");
    let user:Users = localUser?JSON.parse(localUser):undefined;

    const [informesList, setInformesList] = useState<InformeAI[]>([]);



    useEffect(()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };

        fetch(API_AUDITORIAS + "/Lista-de-Informes-AI",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:InformeAI[])=>{
                setInformesList(data);
            })
    },[update])

    
    const nuevoInforme = ()=>{
        //if(planesList[planesList.length-1].Id!==""){
        //    setPlanesList([...planesList,{Id:"",Lugar:"",Fecha:"",Nro_auditoria:"",Objetivo:"",Alcance:"",Criterios:""}])
        //}
        if(informesList.length>0){
            let inf = informesList[informesList.length-1];
            setInformeSelect({
                        Id:"",
                        Organizacion: inf.Organizacion,
                        Direccion:inf.Direccion,
                        Fecha:"",
                        Nro_auditoria:"",
                        Objetivo:inf.Objetivo,
                        Alcance: inf.Alcance,
                        Criterios: inf.Criterios,
                        Documentos_asociados: inf.Documentos_asociados,
                        Conclusion: inf.Conclusion
                        });
        }else{
            setInformeSelect({Id:"",Organizacion:"",Direccion:"",Fecha:"",Nro_auditoria:"",Objetivo:"",Alcance:"",Criterios:"",Documentos_asociados:"",Conclusion:""});
        }
    }

    return(
    <>
        <div 
            className="d-flex flex-column justify-cotent-center align-items-center p-1"
            style={{backgroundColor:"rgba(219, 219, 219, 0.5)"}}
        >
            {
                informesList.map(inf=>(
                    <div className="mx-1" key={inf.Id.toString()}>
                        <button 
                            className={informeSelect?.Id===inf.Id?"btn btn-sm btn-dark" : "btn btn-sm btn-outline-secondary"}
                            onClick={()=>setInformeSelect(inf)}
                        >
                           {inf.Nro_auditoria} | {inf.Fecha.slice(8,10)}/{inf.Fecha.slice(5,7)}/{inf.Fecha.slice(0,4)}
                        </button>
                    </div>
                ))
            }
            <div className="m-1">
                <button
                    className="btn btn-sm btn-outline-primary"
                    disabled={user.Auditoria==="2"?false:true}
                    onClick={()=>nuevoInforme()}
                >NUEVO INFORME</button>
            </div>
            {
                informeSelect?informeSelect.Id===""?
                <div
                    className="alert alert-warning"
                    role="alert"
                >
                    <h4 className="alert-heading">Nuevo Informe</h4>
                    <p>Para completar los campos con los valores del último Informe debe hacer doble click en el campo correspondiente</p>
                    <hr />
                    <p className="mb-0">Esta opción sólo está disponible en la carga de datos previa a la creación del Informe.</p>
                </div>
                :
                <div></div>
                :
                <div></div>
            }
            
            {
                user.Auditoria!=="2"?
                <div
                    className="alert alert-secondary ocultar-al-imprimir"
                    role="alert"
                >
                    <h4 className="alert-heading">Usuario Restringido</h4>
                    <p>El usuario solo tiene permisos de lectura</p>
                    <hr />
                    <p className="mb-0">Debe iniciar sesión con un perfil de Auditor Interno para tener acceso completo
                    </p>
                </div>
                :
                <div></div>
                
            }

        </div>
    </>
    )
}